import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '../../services';
import { Utils } from '../../utils';
import { MessageService } from 'primeng/api';

@Component({
    moduleId: module.id,
    selector: 'app-auth-password-reset',
    templateUrl: 'password.component.html',
    styleUrls: ['password.component.css']
})

export class PasswordComponent implements OnInit {

    model: any = {};
    loading = false;
    returnUrl: string;

    constructor(
        private router: Router,
        private utils: Utils,
        private messageService: MessageService,
        private authenticationService: AuthenticationService) { }

    ngOnInit() {
        this.authenticationService.logout();
    }

    resetPassword(): void {
        this.loading = true;

        this.authenticationService.resetPassword(this.model.username)
            .subscribe(
                () => {
                    this.router.navigate([this.returnUrl]);
                },
                error => {
                    this.loading = false;
                    this.messageService.add({ severity: 'error', summary: 'Błąd generowania hasła', detail: this.utils.handleError(error) });
                });
    }
}
